import { render } from "./companies-list-modal.vue?vue&type=template&id=35896943"
import script from "./companies-list-modal.vue?vue&type=script&lang=js"
export * from "./companies-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__